var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mt-4 mb-6 pt-1 ra-rugl-card"},[_c('v-row',[_c('v-col',[_c('ra-card-info',{attrs:{"test":_vm.test}})],1),_c('v-col',{staticClass:"mr-4"},[_c('rugl-card-info',{attrs:{"test":_vm.test}})],1)],1)],1),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.ra.title")))]),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.ra.measured'),"min":-1,"max":100,"suffix":"Ra","step":"1","value":_vm.measuredRa,"placeholder":"-"},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'measured_ra',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
        _vm.debouncedSetMeasuredRa(value);
      }}}),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.rugl.title")))]),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.rugl.measured'),"min":-1,"max":40,"step":"1","value":_vm.measuredRugl,"placeholder":"-"},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'measured_rugl',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
        _vm.debouncedSetMeasuredRugl(value);
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }